import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as collections from '../collections/redux/actions';
import * as home from '../home/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import { Field, Formik, Form, FieldArray, ErrorMessage } from 'formik';
import LoadingCard from './LoadingCard';
import { toast } from 'react-toastify';
import { EXCLUDED_COLLECTIONS, validationSchema } from './utils';
export class PromptPagesList extends Component {
  static propTypes = {
    aiPromptBuilder: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    collections: PropTypes.object.isRequired,
  };

  state = {
    htmlGenerating: false,
    storedCollections: [],
  };
  async componentDidMount() {
    try {
      const { actions, match, location, collections } = this.props;
      const { version, projectId } = match.params;
      const { state = {} } = location;
      const { userPrompt } = state;
      const { REACT_APP_AI_MODEL, REACT_APP_API_KEY } = process.env;

      const { data: storedCollections = [] } = await collections.loadProjectCollections({
        projectId,
        version,
      });
      this.setState({ storedCollections });
      const dataModelName = storedCollections
        .filter(
          (collection) =>
            !EXCLUDED_COLLECTIONS.includes(collection.orgCollectionName.toLowerCase()),
        )
        .map((collection) => collection.orgCollectionName.toLowerCase());

      const data = {
        userPrompt: userPrompt + ' having data models as ' + [...dataModelName],
        generatedCodeConfig: 'optimal_pages',
        codeGenerationModel: '',
        apiKey: REACT_APP_API_KEY,
        aiModel: REACT_APP_AI_MODEL,
        version,
      };
      await actions.fetchPages(data);
    } catch (error) {
      console.error('❌ Failed to fetch pages:', error);
    }
  }

  handleSubmit = async (values) => {
    const { storedCollections } = this.state;
    const { actions, match, history, location, home } = this.props;
    const { state = {} } = location;
    const { userPrompt, roles = [] } = state;
    const { version, projectId } = match.params;
    const { REACT_APP_AI_MODEL, REACT_APP_API_KEY } = process.env;

    try {
      roles.push('Super Admin');
      const aiPages = [];

      const { data: snippetData } = await home.loadSnippets({ projectId, version });
      const layouts = [];
      const snippetUUIDs = [];

      if (snippetData.length > 0) {
        snippetData.forEach((snippet) => {
          layouts.push({ value: snippet.uuid, label: snippet.name });
          snippetUUIDs.push({ layoutId: snippet.uuid, role: snippet.role });
        });
      }

      for (const value of values.pages) {
        this.setState({ htmlGenerating: true });

        const data = {
          userPrompt: `Create a ${value.name} having ${value.description} for ${userPrompt}`,
          generatedCodeConfig: 'generate_html_code',
          codeGenerationModel: '',
          apiKey: REACT_APP_API_KEY,
          aiModel: REACT_APP_AI_MODEL,
          version,
        };

        const htmlData = await actions.generateHtmlForPages(data);
        if (htmlData.data.success && htmlData.data.noCodeData) {
          const { noCodeHtml, noCodeCss } = htmlData.data.noCodeData;

          for (const role of roles) {
            const matchedSnippet = snippetUUIDs.find(
              (snippet) => snippet.role.toLowerCase() === role.toLowerCase(),
            );
            const pageData = {
              data: {
                name: `${role} ${value.name}`,
                slug: `${role.toLowerCase().replace(/\s+/g, '-')}-${value.name
                  .toLowerCase()
                  .replace(/\s+/g, '-')}-ai-page`,
                cloneFrom: '',
                restoreFrom: '',
                cloneSnippet: '',
                cloneSnippetSnapshot: '',
                collectionId: '',
                access: [role],
                titleTag: '',
                description: '',
                pageImage: '',
                isTitleFromCollection: false,
                isDescriptionFromCollection: false,
                isPageImageFromCollection: false,
                extraMetaTag: '',
                pageIndex: 9999,
                eventName: '',
                pageDirection: 'ltr',
                externalScriptURL: '',
                customScript: '',
                collectionFrom: 'COLLECTION',
                externalApiId: '',
                projectId,
                loadCustomScriptToBuilder: true,
                rlsFilter: null,
                pageLayoutId: matchedSnippet.layoutId,
                content: {
                  'nocode-html': noCodeHtml,
                  'nocode-components': '',
                  'nocode-css': noCodeCss,
                  'nocode-styles': '',
                },
                projectVersion: version,
              },
              version,
              projectId,
            };
            await actions.createPage(pageData);
            aiPages.push({
              name: `${role} ${value.name}`,
              slug: `${role.toLowerCase().replace(/\s+/g, '-')}-${value.name
                .toLowerCase()
                .replace(/\s+/g, '-')}-ai-page`,
            });
          }
        }
      }
      const collectionData = {};
      for (let i = 0; i < storedCollections.length; i++) {
        const collection = storedCollections[i];
        if (!EXCLUDED_COLLECTIONS.includes(collection.collectionName)) {
          collectionData[collection.uuid] = {
            selectedPage: { list: true, update: true, add: true },
            selectedLayout: layouts,
          };
        }
      }
      const createAppRequest = { collectionData, aiPages };
      await actions.createApp({ createAppRequest, projectId, version });
      toast.success('AI Pages generated and app created successfully!');
      history.push(`/on-boarding/${version}/v/${projectId}/summary`);
    } catch (error) {
      console.error('Failed to generate html pages for the application', error);
      toast.error('Failed to generate pages. Please try again.');
    } finally {
      this.setState({ htmlGenerating: false });
    }
  };

  render() {
    const { htmlGenerating } = this.state;
    const { aiPromptBuilder } = this.props;
    const { fetchPagesPending, optimalPages } = aiPromptBuilder;
    let pagesList = [];
    if (optimalPages.data) {
      pagesList = [...optimalPages.data.pages];
    }

    const loading = fetchPagesPending || !pagesList.length;
    if (loading) {
      return (
        <LoadingCard
          headerText="Identifying Pages for Your Application"
          loadingText="Please wait while we are identifying optimal pages for your application..."
          loadingFlag={loading}
          headerIcon="aiModelConfig"
        />
      );
    }

    if (htmlGenerating) {
      return (
        <LoadingCard
          headerText="Generating HTML Code for the pages"
          loadingText="Please wait while we are generating pages for your application..."
          loadingFlag={htmlGenerating}
          headerIcon="aiModelConfig"
        />
      );
    }

    return (
      <CommonPageComponent>
        <div className="row mx-auto">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
            <Formik
              initialValues={{
                pages: pagesList,
              }}
              validationSchema={validationSchema}
              onSubmit={this.handleSubmit}
            >
              {({ values, submitForm, errors, touched }) => (
                <>
                  <ParentContentCard
                    title="AI Suggested Pages For Your Application"
                    icon="aiModelConfig"
                  >
                    <div className="center-div">
                      <div className="container ml-5 mb-4">
                        <h5 style={{ textTransform: 'none' }}>
                          The pages and their descriptions below have been automatically generated
                          based on your application. You can review, edit, add, or remove them to
                          better suit your needs.
                        </h5>
                        <h5 className="mb-4" style={{ textTransform: 'none' }}>
                          <strong>Note:</strong> The system will generate default CRUD Pages.
                        </h5>
                      </div>
                    </div>
                    <div className="d-flex justify-content-center">
                      <div className="w-75">
                        <Form>
                          <FieldArray name="pages">
                            {({ push, remove }) => (
                              <>
                                <div>
                                  {values.pages.map((_, index) => (
                                    <div key={index} className="form-row mb-2">
                                      <div className="col-sm-3">
                                        <Field
                                          type="text"
                                          name={`pages[${index}].name`}
                                          className="form-control form-control-sm"
                                          disabled={values.pages[index].disabled}
                                          placeholder="Page Name"
                                        />
                                        <ErrorMessage name={`pages[${index}].name`}>
                                          {(msg) => <div className="text-danger">{msg}</div>}
                                        </ErrorMessage>
                                      </div>
                                      <div className="col-sm-7">
                                        <Field
                                          type="text"
                                          name={`pages[${index}].description`}
                                          disabled={values.pages[index].disabled}
                                          className="form-control form-control-sm"
                                          placeholder="Page Description"
                                        />
                                        <ErrorMessage name={`pages[${index}].description`}>
                                          {(msg) => <div className="text-danger">{msg}</div>}
                                        </ErrorMessage>
                                      </div>
                                      <div className="col-sm-2">
                                        <button
                                          className="btn btn-xs btn-theme-delete btn-icon-only"
                                          type="button"
                                          onClick={() => remove(index)}
                                        >
                                          <i className="wb webconnect-times"></i>
                                        </button>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                                <div className="d-flex justify-content-end m-4 mt-5">
                                  <button
                                    type="button"
                                    className="btn btn-theme-submit btn-sm"
                                    onClick={() => push('')}
                                  >
                                    <i className="wb webconnect-plus"></i> Add Page
                                  </button>
                                </div>
                              </>
                            )}
                          </FieldArray>
                        </Form>
                      </div>
                    </div>
                  </ParentContentCard>
                  <div className="d-flex justify-content-end mr-4">
                    <button
                      type="button"
                      className="btn btn-theme-submit btn-md"
                      title="Save & Go to Next Step"
                      onClick={submitForm}
                    >
                      <i className="wb webconnect-save-regular"></i>&nbsp;Create Pages & Continue
                    </button>
                  </div>
                </>
              )}
            </Formik>
          </div>
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    aiPromptBuilder: state.aiPromptBuilder,
    collections: state.collections,
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    collections: bindActionCreators({ ...collections }, dispatch),
    home: bindActionCreators({ ...home }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PromptPagesList);
